import * as Yup from 'yup'

import { getShowBudgetSection } from './helper'
import { getImpressionsValidation } from '../../../UploadAdCreative/ImpressionsBudgetSection/validation'
import {
  campaignObjectiveValidation,
  campaignValidation,
  getBudgetValidation
} from '../../../UploadAdCreative/UploadAdCreativeCampaignForm/fields'

import { BUDGET_LIFETIME, IOS_14_CAMPAIGN, NAME } from './fields'
import { OBJECTIVE } from '../../../CampaignForms/fields'
import { LIST_ITEM_OPTION, OPTION_NEW_LIST_ITEM } from '../../../../../hooks/formHooks/listItemFormHooks/fields'
import { leadsOrSalesObjectives } from '../../../../Facebook/UploadFacebookAdCreative/UploadFacebookAdCreativeForm/CampaignForm/NewCampaignFields/hooks'
import { OUTCOME_APP_PROMOTION } from '../../../../../constants/campaigns'
import { APPLICATION_ID } from '../../../../Facebook/UploadFacebookAdCreative/UploadFacebookAdCreativeForm/reusableFields/AppListField/fields'
import { IMPRESSIONS } from '../../../UploadAdCreative/fields'
import { AUTO_OPTIMIZED_CAMPAIGN_BUDGET } from '../../../../reusableFields'

export const validationSchema = Yup.object({
  [NAME]: Yup.string().required('Name required')
})

interface GetValidationSchemaParams {
  remainingBudget: number
  remainingImpressions: number
  currencySymbol: string
  allocationTypeImpressions: boolean
  hasMissingDatasetAndCustomConversion: boolean
  hasMissingClientApps: boolean
}

export const getValidationSchema = ({
  remainingBudget,
  remainingImpressions,
  currencySymbol,
  allocationTypeImpressions,
  hasMissingDatasetAndCustomConversion,
  hasMissingClientApps
}: GetValidationSchemaParams) => {
  return Yup.object({
    ...campaignValidation,
    ...campaignObjectiveValidation,
    ...(hasMissingDatasetAndCustomConversion && {
      [OBJECTIVE]: Yup.string().when(LIST_ITEM_OPTION, {
        is: OPTION_NEW_LIST_ITEM,
        then: () => {
          return Yup.string().notOneOf(leadsOrSalesObjectives, 'Please select another goal')
        }
      })
    }),
    ...(hasMissingClientApps && {
      [OBJECTIVE]: Yup.string().when(LIST_ITEM_OPTION, {
        is: OPTION_NEW_LIST_ITEM,
        then: () => {
          return Yup.string().notOneOf([OUTCOME_APP_PROMOTION], 'Please select another goal')
        }
      })
    }),

    [APPLICATION_ID]: Yup.string().when([OBJECTIVE, LIST_ITEM_OPTION, IOS_14_CAMPAIGN], {
      is: (objective: string, listItemOption: string, ios14CampaignToggle: boolean) => {
        return objective === OUTCOME_APP_PROMOTION && listItemOption === OPTION_NEW_LIST_ITEM && ios14CampaignToggle
      },
      then: () => Yup.string().required('App is required')
    }),

    ...(allocationTypeImpressions
      ? {
          [IMPRESSIONS]: Yup.number().when(LIST_ITEM_OPTION, {
            is: OPTION_NEW_LIST_ITEM,
            then: () =>
              Yup.number().when([OBJECTIVE, AUTO_OPTIMIZED_CAMPAIGN_BUDGET], {
                is: (objective: string, autoOptimisedCampaignBudget: boolean) => {
                  return getShowBudgetSection(objective) && autoOptimisedCampaignBudget
                },
                then: () =>
                  getImpressionsValidation({
                    remainingImpressions
                  })
              })
          })
        }
      : {
          [BUDGET_LIFETIME]: Yup.number().when(LIST_ITEM_OPTION, {
            is: OPTION_NEW_LIST_ITEM,
            then: () =>
              Yup.number().when([OBJECTIVE, AUTO_OPTIMIZED_CAMPAIGN_BUDGET], {
                is: (objective: string, autoOptimisedCampaignBudget: boolean) => {
                  return getShowBudgetSection(objective) && autoOptimisedCampaignBudget
                },
                then: () => getBudgetValidation({ remainingBudget, currencySymbol })
              })
          })
        })
  })
}
